import { cn } from "@/lib/cn";

// Skeleton — pulsing placeholder. Set `lines` to render a stack of
// 14-px bars; pass `className` for any other shape.
export function Skeleton({ lines = 1, className }: { lines?: number; className?: string }) {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "h-3.5 w-full animate-pulse rounded-md bg-bg-3",
            className,
          )}
        />
      ))}
    </div>
  );
}
